/*
 * Interactive size guide (snippets/cp-size-guide.liquid).
 *
 *   chip      → that size's column lights up, the line under the chips
 *               spells it out, the pinned button names it;
 *   table row → the measurement lights up on the drawing, the tip says how
 *               to measure it;
 *   number    → the nearest size for the chosen measurement is picked;
 *   button    → product page: sets the size in the form and closes the guide;
 *               size page: opens the catalogue filtered to that size.
 *
 *   height × weight → where the chart has the table, two taps name the size.
 *
 * The last size picked is remembered per kind (cp:sg-top / -bottom / -shorts)
 * and preselected next time — the second product needs no clicking at all.
 * Delegated from document so the product page overlay and the size page
 * share one listener.
 */
(function () {
  var KEY = 'cp:sg-';

  function store(group, size) { try { localStorage.setItem(KEY + group, size); } catch (e) {} }
  function recall(group) { try { return localStorage.getItem(KEY + group); } catch (e) { return null; } }

  function panelOf(el) { return el.closest('[data-cp-sg-panel]'); }
  function rootOf(el) { return el.closest('[data-cp-sg]'); }
  function activePanel(root) { return root.querySelector('[data-cp-sg-panel]:not([hidden])'); }

  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  function selectSize(panel, size, opts) {
    var root = rootOf(panel);
    panel.dataset.size = size;
    // A size picked by hand no longer matches the height × weight answer.
    if (!opts || opts.how !== 'fit') {
      var box = panel.querySelector('[data-cp-sg-fit]');
      var lit = box && box.querySelector('.is-hit');
      if (lit && lit.dataset.fit.split('/').indexOf(size) < 0) {
        lit.classList.remove('is-hit');
        box.querySelectorAll('[data-cp-sg-h], [data-cp-sg-w]').forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-pressed', 'false'); });
        box.querySelector('[data-cp-sg-fit-result]').textContent = 'Оберіть зріст і вагу — назвемо розмір.';
      }
    }
    panel.querySelectorAll('[data-cp-sg-size]').forEach(function (c) {
      var on = c.dataset.cpSgSize === size;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', String(on));
    });
    panel.querySelectorAll('[data-cp-sg-col]').forEach(function (cell) {
      cell.classList.toggle('is-col', cell.dataset.cpSgCol === size);
    });

    var parts = [];
    panel.querySelectorAll('tr[data-cp-sg-row]').forEach(function (row) {
      var cell = row.querySelector('td[data-cp-sg-col="' + size + '"]');
      if (cell) parts.push((row.dataset.short || row.dataset.label.toLowerCase()) + ' ' + String(cell.dataset.v).replace('.', ',') + ' см');
    });
    var says = panel.querySelector('[data-cp-sg-says]');
    var chip = panel.querySelector('[data-cp-sg-size="' + size + '"]');
    var out = chip && chip.classList.contains('is-out');
    if (says) says.innerHTML = '<b>' + size + ':</b> ' + parts.join(', ') + (out ? '. <span class="cp-sg__out">Цього розміру зараз немає.</span>' : '.');

    var cta = root.querySelector('[data-cp-sg-cta]');
    if (cta) {
      cta.disabled = false;
      cta.dataset.size = size;
      cta.textContent = root.dataset.context === 'pdp'
        ? (out ? 'Розміру ' + size + ' немає — оберіть інший' : 'Обрати розмір ' + size)
        : 'Дивитись речі розміру ' + size;
      if (root.dataset.context === 'pdp' && out) cta.disabled = true;
    }
    if (!opts || !opts.silent) {
      // Remembered per kind of garment (top / bottom / shorts): the M picked
      // on a bomber is preselected on the next jacket, not on trousers.
      store(panel.dataset.kind || panel.dataset.cpSgPanel, size);
      track('cp_size_guide_pick', { size: size, chart: panel.dataset.cpSgPanel, how: (opts && opts.how) || 'chip' });
    }
  }

  function showParam(panel, name) {
    panel.querySelectorAll('tr[data-cp-sg-row]').forEach(function (r) { r.classList.toggle('is-row', r.dataset.cpSgRow === name); });
    panel.querySelectorAll('[data-cp-sg-line]').forEach(function (l) { l.classList.toggle('is-on', l.dataset.cpSgLine === name); });
    var row = panel.querySelector('tr[data-cp-sg-row="' + name + '"]');
    var tip = panel.querySelector('[data-cp-sg-tip]');
    if (row && tip) tip.innerHTML = '<b>' + row.dataset.label + '.</b> ' + row.dataset.tip;
    var sel = panel.querySelector('[data-cp-sg-param]');
    if (sel && sel.value !== name) sel.value = name;
  }

  /* Tabs (a set: two charts) and the model picker (the size page) both land here. */
  function showPanel(root, key) {
    root.querySelectorAll('[data-cp-sg-group]').forEach(function (g) {
      var on = g.dataset.cpSgGroup === key;
      g.classList.toggle('is-on', on);
      g.setAttribute('aria-selected', String(on));
    });
    root.querySelectorAll('[data-cp-sg-panel]').forEach(function (p) { p.hidden = p.dataset.cpSgPanel !== key; });
    var p = activePanel(root);
    var cta0 = root.querySelector('[data-cp-sg-cta]');
    if (p && p.dataset.size) selectSize(p, p.dataset.size, { silent: true });
    else if (cta0) { cta0.disabled = true; cta0.textContent = 'Оберіть розмір вище'; }
  }

  /* Height × weight: both picked → the cell lights up, the size is named and
     chosen. "M/L" means either; the smaller is chosen and the line says why
     the bigger one is there too. */
  function fit(box) {
    var h = box.querySelector('[data-cp-sg-h].is-on');
    var w = box.querySelector('[data-cp-sg-w].is-on');
    var out = box.querySelector('[data-cp-sg-fit-result]');
    box.querySelectorAll('[data-cp-sg-cell]').forEach(function (c) { c.classList.remove('is-hit'); });
    if (!h || !w) { out.textContent = h ? 'Тепер оберіть вагу.' : 'Тепер оберіть зріст.'; return; }
    var cell = box.querySelector('[data-cp-sg-cell="' + h.dataset.cpSgH + '-' + w.dataset.cpSgW + '"]');
    if (!cell) return;
    cell.classList.add('is-hit');
    var opts = cell.dataset.fit.split('/');
    var panel = panelOf(box);
    selectSize(panel, opts[0], { how: 'fit' });
    out.innerHTML = opts.length > 1
      ? 'Вам підійде <b>' + opts[0] + '</b> або <b>' + opts[1] + '</b>: ' + opts[0] + ' сидить рівніше, ' + opts[1] + ' — вільніше. Обрали ' + opts[0] + '.'
      : 'Вам підійде <b>' + opts[0] + '</b>.';
  }

  function nearest(panel) {
    var sel = panel.querySelector('[data-cp-sg-param]');
    var input = panel.querySelector('[data-cp-sg-cm]');
    var result = panel.querySelector('[data-cp-sg-result]');
    var cm = parseFloat(String(input.value).replace(',', '.'));
    var fmt = function (n) { return String(n).replace('.', ','); };
    if (!cm) { result.textContent = ''; return; }
    var best = null;
    panel.querySelectorAll('tr[data-cp-sg-row="' + sel.value + '"] td[data-cp-sg-col]').forEach(function (td) {
      var d = Math.abs(parseFloat(td.dataset.v) - cm);
      if (!best || d < best.d) best = { d: d, size: td.dataset.cpSgCol, v: td.dataset.v };
    });
    if (!best) return;
    showParam(panel, sel.value);
    selectSize(panel, best.size, { how: 'compare' });
    result.innerHTML = best.d <= 2
      ? 'Ваш замір ' + fmt(cm) + ' см — це <b>' + best.size + '</b> (' + fmt(best.v) + ' см).'
      : 'Найближчий — <b>' + best.size + '</b> (' + fmt(best.v) + ' см). Різниця ' + Math.round(best.d) + ' см: якщо сумніваєтесь, напишіть нам.';
  }

  function init(root) {
    if (root.dataset.cpSgReady) return;
    root.dataset.cpSgReady = '1';
    root.querySelectorAll('[data-cp-sg-panel]').forEach(function (panel) {
      var first = panel.querySelector('tr[data-cp-sg-row]');
      if (first) showParam(panel, first.dataset.cpSgRow);
      var remembered = recall(panel.dataset.kind || panel.dataset.cpSgPanel);
      if (remembered && panel.querySelector('[data-cp-sg-size="' + remembered + '"]')) selectSize(panel, remembered, { silent: true });
    });
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    var chip = t.closest('[data-cp-sg-size]');
    if (chip) { selectSize(panelOf(chip), chip.dataset.cpSgSize); return; }

    var row = t.closest('tr[data-cp-sg-row]');
    if (row) {
      showParam(panelOf(row), row.dataset.cpSgRow);
      var td = t.closest('td[data-cp-sg-col]');
      if (td) selectSize(panelOf(row), td.dataset.cpSgCol, { how: 'cell' });
      return;
    }

    var line = t.closest('[data-cp-sg-line]');
    if (line) { showParam(panelOf(line), line.dataset.cpSgLine); return; }

    var group = t.closest('[data-cp-sg-group]');
    if (group) { showPanel(rootOf(group), group.dataset.cpSgGroup); return; }

    var opt = t.closest('[data-cp-sg-h], [data-cp-sg-w]');
    if (opt) {
      var box = opt.closest('[data-cp-sg-fit]');
      var attr = opt.hasAttribute('data-cp-sg-h') ? 'data-cp-sg-h' : 'data-cp-sg-w';
      box.querySelectorAll('[' + attr + ']').forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-pressed', String(on));
      });
      fit(box);
      return;
    }

    var cellFit = t.closest('[data-cp-sg-cell]');
    if (cellFit) {
      var box2 = cellFit.closest('[data-cp-sg-fit]');
      var hw = cellFit.dataset.cpSgCell.split('-');
      box2.querySelectorAll('[data-cp-sg-h]').forEach(function (o) { var on = o.dataset.cpSgH === hw[0]; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', String(on)); });
      box2.querySelectorAll('[data-cp-sg-w]').forEach(function (o) { var on = o.dataset.cpSgW === hw[1]; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', String(on)); });
      fit(box2);
      return;
    }

    var cta = t.closest('[data-cp-sg-cta]');
    if (cta && !cta.disabled) {
      var r = rootOf(cta);
      var size = cta.dataset.size;
      track('cp_size_guide_apply', { size: size, context: r.dataset.context });
      if (r.dataset.context === 'pdp') {
        var input = Array.prototype.find.call(document.querySelectorAll('.size-option-input'), function (i) {
          return String(i.value).trim().toUpperCase() === size && !i.disabled;
        });
        if (input) {
          var label = document.querySelector('label[for="' + input.id + '"]');
          (label || input).click();
        }
        if (typeof window.closeSizeGuide === 'function') window.closeSizeGuide();
      } else {
        window.location.href = '/collections/catalog?size=' + encodeURIComponent(size);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var row = event.target.closest && event.target.closest('tr[data-cp-sg-row]');
    if (row) { event.preventDefault(); showParam(panelOf(row), row.dataset.cpSgRow); }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-cp-sg-cm]')) nearest(panelOf(event.target));
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-cp-sg-pick]')) {
      showPanel(rootOf(event.target), event.target.value);
      track('cp_size_guide_model', { chart: event.target.value });
      return;
    }
    if (event.target.matches('[data-cp-sg-param]')) {
      var panel = panelOf(event.target);
      showParam(panel, event.target.value);
      nearest(panel);
    }
  });

  function boot() { document.querySelectorAll('[data-cp-sg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
